import React from 'react'
import styled from 'particles/themes/styled'
import Icon from 'components/Icon/Icon'
import LanguageFilter from 'components/NavBar/LanguageFilter'

interface HeaderProps {
    className?: string
}

const Header: React.FC<HeaderProps> = ({ className }) => {
    return (
        <div className={className}>
            <Icon.FullLogoIcon height="49px" width="165px" />
            <div style={{ width: '160px' }}>
                <LanguageFilter isSignUp />
            </div>
        </div>
    )
}
export default styled(Header)`
    width: 100%;
    display: flex;
    height: fit-content;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 375px) {
        margin-bottom: 40px;
    }
`
